import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button, Input, Spinner } from "reactstrap";
import { Avatar } from "antd";
import {
  UserOutlined,
  EditOutlined,
  EyeInvisibleTwoTone,
  EyeTwoTone,
} from "@ant-design/icons";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateMarchandById } from "../../services/merchandApi";
import { useQueryClient } from "react-query";
import FormField from "../../../../common/Form/FormField";
import { updatePassword } from "../../../auth/services/authApi";
import toast from "react-hot-toast";
const ProfileDetailAdmin = ({ currentuser }) => {
   const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  const user = currentUser?.user || {};
  const merchandId = user?.id;
  const queryClient = useQueryClient();
  const [editingInfos, setEditingInfos] = useState(false);
  const [editingPassword, setEditingPassword] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
    const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(null);
  const formikInfos = useFormik({
    initialValues: {
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      adresse: user.adresse || "",
      phoneNumber: user.phoneNumber || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Prénom requis"),
      lastName: Yup.string().required("Nom requis"),
      adresse: Yup.string().required("Adresse requise"),
      phoneNumber: Yup.string().required("Téléphone requis"),
    }),
    onSubmit: async (values) => {
      setIsLoadingSubmit(true);
      try {
        await updateMarchandById({ ...values, merchandId });
        toast.success("Informations mises à jour 🎉");
        await queryClient.invalidateQueries("auth");
        setEditingInfos(false);
      } catch (error) {
        toast.error(error || "Erreur lors de la mise à jour.");
      } finally {
        setIsLoadingSubmit(false);
      }
    },
    enableReinitialize: true,
  });

  const formikPassword = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Ancien mot de passe requis"),
      newPassword: Yup.string()
        .min(8, "Minimum 8 caractères")
        .matches(/[A-Z]/, "Doit contenir une majuscule")
        .matches(/[0-9]/, "Doit contenir un chiffre")
        .required("Nouveau mot de passe requis"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Les mots de passe doivent correspondre")
        .required("Confirmation obligatoire"),
    }),
   onSubmit: async (values) => {
  const payload = {
    email: user.email,
    oldPassword: values.oldPassword, 
    newPassword: values.newPassword,
  };

  try {
  setIsLoadingPassword(true);
  await updatePassword(payload);
  toast.success("Mot de passe changé avec succès 🔐");

  setTimeout(() => {
    setEditingPassword(false);
    formikPassword.resetForm();
  }, 500);

} catch (error) {
  toast.error(
    error?.response?.data?.message || "Échec de la mise à jour"
  );
} finally {
  setIsLoadingPassword(false);
}
},
});
 
  return (
    <Card className="shadow-sm border-0 rounded-lg">
      <CardBody className="p-4">
        <div className="mb-4 " style={{fontSize: '20px',fontFamily: 'Poppins, sans-serif', fontWeight: 500, color: '#212529'}}>Mon profile</div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center gap-3">
            <Avatar size={64} icon={<UserOutlined />} />
            <div>
              <div className="mb-0 "style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#212529'}}>
                {formikInfos.values.firstName} {formikInfos.values.lastName}
              </div>
              <div className=" mb-0"style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#212529BF'}}>{currentUser?.roles || "-"}</div>
              <small style={{fontSize: '14px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#212529BF'}}>{currentUser?.email || "-"}</small>
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}}>Informations personnelles</div>
          {!editingInfos && (
            <Button size="sm" type="link" onClick={() => setEditingInfos(true)} style={{border:'#4379F2',backgroundColor:'#4379F2',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}}>
              <EditOutlined /> Éditer
            </Button>
          )}
        </div>
        <form onSubmit={formikInfos.handleSubmit}>
          <Row className="mb-1 text-muted fw-semibold">
            <Col style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}} md={3}>Prénom</Col>
            <Col style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}} md={3}>Nom</Col>
            <Col style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}} md={3}>Adresse</Col>
            <Col style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}} md={3}>Téléphone</Col>
          </Row>
          <Row className="align-items-center mb-3">
            {["firstName", "lastName", "adresse", "phoneNumber"].map((field) => (
              <Col md={3} key={field}>
                {editingInfos ? (
                  <>
                    <Input
                      name={field}
                      value={formikInfos.values[field]}
                      onChange={formikInfos.handleChange}
                      onBlur={formikInfos.handleBlur}
                      className={
                        formikInfos.touched[field] && formikInfos.errors[field]
                          ? "is-invalid"
                          : ""
                      }
                    />
                    {formikInfos.touched[field] && formikInfos.errors[field] && (
                      <div className="text-danger small">{formikInfos.errors[field]}</div>
                    )}
                  </>
                ) : (
                  <span style={{fontSize: '16px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#212529'}}>{formikInfos.values[field]}</span>
                )}
              </Col>
            ))}
          </Row>
          {editingInfos && (
            <div className="text-end">
              <Button
                className="me-2"
                style={{border:'#DB2222',backgroundColor:'#DB2222',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}}
                color="secondary"
                onClick={() => setEditingInfos(false)}
                disabled={isLoadingSubmit}
              >
                Annuler
              </Button>
              <Button style={{border:'#4379F2',backgroundColor:'#4379F2',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}} type="submit" disabled={isLoadingSubmit}>
                {isLoadingSubmit ? <Spinner size="sm" /> : "Sauvegarder"}
              </Button>{" "}
            </div>
          )}
        </form>
        <hr />
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div style={{fontSize: '16px',fontFamily: 'Poppins, sans-serif', fontWeight: 700, color: '#212529BF'}}>Sécurité</div>
          {!editingPassword && (
            <Button style={{border:'#4379F2',backgroundColor:'#4379F2',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}} size="sm" type="link" onClick={() => setEditingPassword(true)}>
              <EditOutlined /> Éditer
            </Button>
          )}
        </div>
        <form onSubmit={formikPassword.handleSubmit}>
          <Row>
            <Col style={{fontSize: '16px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#212529BF'}} md={3}>Mot de passe</Col>
            <Col md={9}>
              {editingPassword ? (
                <Row className="mt-2">
                  {errorUpdate && <div className="alert alert-danger">{errorUpdate}</div>}
                  <FormField
                    label="Ancien mot de passe"
                    name="oldPassword"
                    formik={formikPassword}
                    type={showPassword ? "text" : "password"}
                    colSize={12}
                    icon={
                      showPassword ? (
                        <EyeInvisibleTwoTone
                          onClick={() => setShowPassword(false)}
                        />
                      ) : (
                        <EyeTwoTone onClick={() => setShowPassword(true)} />
                      )
                    }
                  />
                  <FormField
                    label="Nouveau mot de passe"
                    name="newPassword"
                    formik={formikPassword}
                    type={showNew ? "text" : "password"}
                    colSize={12}
                    icon={
                      showNew ? (
                        <EyeInvisibleTwoTone
                          onClick={() => setShowNew(false)}
                        />
                      ) : (
                        <EyeTwoTone onClick={() => setShowNew(true)} />
                      )
                    }
                  />

                  <FormField
                    label="Confirmer le mot de passe"
                    name="confirmPassword"
                    formik={formikPassword}
                    type={showConfirm ? "text" : "password"}
                    colSize={12}
                    icon={
                      showConfirm ? (
                        <EyeInvisibleTwoTone
                          onClick={() => setShowConfirm(false)}
                        />
                      ) : (
                        <EyeTwoTone onClick={() => setShowConfirm(true)} />
                      )
                    }
                  />
                </Row>
              ) : (
                <strong>************</strong>
              )}
            </Col>
          </Row>

          {editingPassword && (
            <div className="text-end mt-3">
              <Button
               style={{border:'#DB2222',backgroundColor:'#DB2222',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}}
                className="me-2"
                onClick={() => setEditingPassword(false)}
                disabled={isLoadingPassword}
              >
                Annuler
              </Button>
             <Button type="submit" disabled={isLoadingPassword}style={{border:'#DC6B0F', backgroundColor:'#DC6B0F',color:'#FFFFFF'}}>{isLoadingPassword ? <Spinner size="sm" /> : "Modifier"}
            </Button>
            </div>
          )}
        </form>
      </CardBody>
    </Card>
  );
};

export default ProfileDetailAdmin;
